import React from 'react';
import { Collapse } from 'react-collapse';

// Styles are included globaly. See styled-components/collapse.js

type CollapseListItemPropsType = {
  isOpened?: boolean;
  children: React.ReactNode;
  className?: string;
};
const CollapseListItem = ({ isOpened = false, children, className = '' }: CollapseListItemPropsType) => {
  return (
    <Collapse className={className} isOpened={isOpened} theme={{ collapse: 'CollapseListItem-collapse' }}>
      {children}
    </Collapse>
  );
};

export default CollapseListItem;
